import { WebRequest } from 'framework-ui-components';

const Login = (username, password, rememberMe) => WebRequest.post('Utente/Login', { username, password, rememberMe });

const DeveFornireAutorizzazioni = () => WebRequest.get('Utente/DeveFornireAutorizzazioni');

const RecuperaPassword = (username, clientId, referer) => WebRequest.post('Utente/RecuperaPassword', { username, clientId, referer });

const ResettaPassword = (username, nuovaPassword, token, MailRecupero) => WebRequest.post('Utente/ResettaPassword', {
  username, nuovaPassword, token, MailRecupero,
});

const RecuperaApplicazioni = () => WebRequest.post('/Utente/RecuperaApplicazioni');

const Actions = {
  Login, DeveFornireAutorizzazioni, RecuperaPassword, ResettaPassword, RecuperaApplicazioni,
};

export default Actions;
